require './bases'
require './logins'
require './utilization'
require './license-and-base-delete-setup'
